const crossBorderInit = () => {
    const countriesList = [
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Niemiec z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Niemczech?',
                turnOnBtnText: 'Włącz sprzedaż do Niemiec',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174755&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174764&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce w Niemczech',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175003&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/integracja-idosell-z-geizhals-i-guenstiger-wlacz-nowe-porownywarki-cenowe-dla-niemiec-i-austrii-1235327612',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                    ],
                },
            },
            name: 'Niemcy',
            population: '84,7 mln',
            language: 'niemiecki',
            popularPayment: 'PayPal, Mastercard, Visa, Klarna, portfele cyfrowe',
            currency: 'EUR',
            numberOfEstores: '93,42%',
            trends: [
                'Zakupy na Amazon to prawie 1/3 sprzedaży online',
                'Najwyższy wskaźnik zwrotów w Europie – ponad 50 proc. zakupionych towarów ',
                'Najpopularniejsze płatności to PayPal i Klarna',
            ],
            growthRate: '4.6%',
            cta: {
                name: 'Przejdż do podstrony o Niemczech',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=174105&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Niemczech',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać do Niemiec w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w Niemczech',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do sprzedaży w Niemczech. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Skieruj ruch bezpośrednio do sklepu i eksportuj towary do popularnych porównywarek cenowych, m.in. Geizhals.de, Idealo.de. Twoi klienci będą mogli zapłacić poprzez PayPal, Klarna lub Stripe. ',
                    },
                ],
            },
            integrations: [
                1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 27, 28, 29, 35, 36, 37, 38, 39, 44,
            ],
        },

        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Czech z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Czechach?',
                turnOnBtnText: 'Włącz sprzedaż do Czech',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174749&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174462&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce w Czechach',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175002&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wejdz-w-cross-border-i-sprzedawaj-do-czech-i-slowacji-sprawdz-jak-wyglada-e-commerce-u-naszych-sasiadow-1235327521',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175011&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/buduj-wlasna-marke-i-sprzedawaj-w-europie-srodkowo-wschodniej-dlaczego-warto-wejsc-w-cross-border-wlasnie-teraz-1235327482',
                        },
                    ],
                },
            },
            name: 'Czechy',
            population: '10.8 mln',
            language: 'czeski',
            popularPayment: 'płatność za pobraniem',
            currency: 'CZK',
            numberOfEstores: '93%',
            trends: [
                'Punkty odbioru to ulubiona forma dostawy',
                'Większość płatności jest za pobraniem',
                'Najpopularniejsze branże to moda, żywność i elektronika. ',
            ],
            growthRate: '8,3%',
            cta: {
                name: 'Przejdż do podstrony o Czechach',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=173521&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Czechach',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do sprzedaży w Czechach. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Skieruj ruch bezpośrednio do sklepu poprzez porównywarki Heureka.cz oraz Zbozi.cz. Dzięki integracji z Packeta twoi klienci odbiorą zakupy w swoim ulubionym punkcie odbioru lub automacie paczkowym. ',
                    },
                ],
            },
            integrations: [
                1, 2, 3, 4, 5, 6, 7, 8, 11, 12, 13, 14, 15, 16, 17, 19, 20, 29, 35, 41, 42, 44,
            ],
        },

        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Rumunii z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Rumunii?',
                turnOnBtnText: 'Włącz sprzedaż do Rumunii',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174751&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174769&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce w Rumunii',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175011&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/buduj-wlasna-marke-i-sprzedawaj-w-europie-srodkowo-wschodniej-dlaczego-warto-wejsc-w-cross-border-wlasnie-teraz-1235327482',
                        },
                    ],
                },
            },
            name: 'Rumunia',
            population: '19 mln',
            language: 'rumuński',
            popularPayment: 'Płatności za pobraniem, płatności kartowe, bankowość online',
            currency: 'RON',
            numberOfEstores: '91,56%',
            trends: [
                'Dla konsumentów w Rumunii istotna jest niska cena, szybka dostawa oraz rekomendacje, które pochodzą z grona znajomych ',
                'Najniższy podatek VAT w Europie -19% ',
                'Największy marketplace - eMAG.ro',
            ],
            growthRate: '7,4%',
            cta: {
                name: 'Przejdż do podstrony o Rumunii',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=173540&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Rumunii',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do Rumunii. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Skieruj ruch bezpośrednio do sklepu poprzez popularną porównywarkę cenową Compari.ro. Integracja z usługą fulfillmentu Frisbo umożliwi dostawę towarów na następny dzień na terenie całej Rumunii w cenie kuriera lokalnego. ',
                    },
                ],
            },
            integrations: [1, 2, 3, 4, 5, 6, 7, 8, 10, 13, 14, 15, 16, 17, 19, 29, 35, 46],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Węgier z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce na Węgrzech?',
                turnOnBtnText: 'Włącz sprzedaż do Węgier',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174750&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174776&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce w Węgrzech',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175011&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/buduj-wlasna-marke-i-sprzedawaj-w-europie-srodkowo-wschodniej-dlaczego-warto-wejsc-w-cross-border-wlasnie-teraz-1235327482',
                        },
                    ],
                },
            },
            name: 'Węgry',
            population: '9,6 mln',
            language: 'węgierski',
            popularPayment: 'Płatności za pobraniem',
            currency: 'HUF',
            numberOfEstores: '92%',
            trends: [
                'Węgierscy konsumenci chętnie wybierają płatność za pobraniem',
                'Klienci dokonują świadomych zakupów - dokładnie analizują oferty oraz rzadko zwracają produkty ',
                'Węgrzy chętnie kupują zza granicy - ceny wielu towarów są niższe',
            ],
            growthRate: '9,7%',
            cta: {
                name: 'Przejdż do podstrony o Węgrzech',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=173542&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Węgrzech',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do sprzedaży na Węgrzech. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Skieruj ruch bezpośrednio do sklepu poprzez popularne porównywarki cenowe Arukereso.hu oraz Argep.hu. Dzięki integracji z PayU rozliczysz płatności w forintach. ',
                    },
                ],
            },
            integrations: [1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 19, 29, 35, 40, 47],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Bułgarii z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Bułgarii?',
                turnOnBtnText: 'Włącz sprzedaż do Bułgarii',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174752&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174770&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce w Bułgarii',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175011&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/buduj-wlasna-marke-i-sprzedawaj-w-europie-srodkowo-wschodniej-dlaczego-warto-wejsc-w-cross-border-wlasnie-teraz-1235327482',
                        },
                    ],
                },
            },
            name: 'Bułgaria',
            population: '6,45 mln',
            language: 'bułgarski',
            popularPayment: 'Mastercard, Visa, portfele cyfrowe',
            currency: 'BGN',
            numberOfEstores: '83%',
            trends: [
                'E-commerce to tylko 1,3 proc. całości sprzedaży detalicznej',
                'Bułgarzy nie są zamożni, o zakupie decyduje głównie cena',
                'Zdecydowana większość konsumentów kupuje online za pomocą komputera',
            ],
            growthRate: '13,7%',
            cta: {
                name: 'Przejdż do podstrony o Bułgarii',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=173546&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Bułgarii',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do sprzedaży w Bułgarii. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Skieruj ruch bezpośrednio do sklepu poprzez popularną porównywarkę cenową Pazaruvaj.bg. Zakupione towary dostarczysz do ulubionych przez klientów punktów odbioru lub automatów paczkowych dzięki integracji z Packeta. ',
                    },
                ],
            },
            integrations: [1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 19, 29, 35, 45],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Słowacji z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Słowacji?',
                turnOnBtnText: 'Włącz sprzedaż do Słowacji',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174753&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174771&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce w Słowacji',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175002&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wejdz-w-cross-border-i-sprzedawaj-do-czech-i-slowacji-sprawdz-jak-wyglada-e-commerce-u-naszych-sasiadow-1235327521',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175011&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/buduj-wlasna-marke-i-sprzedawaj-w-europie-srodkowo-wschodniej-dlaczego-warto-wejsc-w-cross-border-wlasnie-teraz-1235327482',
                        },
                    ],
                },
            },
            name: 'Słowacja',
            population: '5,4 mln',
            language: 'słowacki',
            popularPayment: 'Płatności za pobraniem',
            currency: 'EUR',
            numberOfEstores: '89%',
            trends: [
                'Słowacy najczęściej kupują z Chin (45%), Czech (32%) oraz z Polski (5%)',
                'Najczęściej wybierane są płatności za pobraniem',
                'Konsumenci w Słowacji dokładnie analizują ceny i porównują oferty przed zakupem',
            ],
            growthRate: '7,9%',
            cta: {
                name: 'Przejdż do podstrony o Słowacji',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=173539&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Słowacji',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do Słowacji. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Skieruj ruch bezpośrednio do sklepu poprzez popularną porównywarkę cenową Heureka.sk. Szybkie i tanie dostawy umożliwi ci integracja z Packeta. Dzięki integracji z PayU rozliczysz płatności w forintach. Aktywuj IdoPay i rozliczaj płatności w euro bez przewalutowania.',
                    },
                ],
            },
            integrations: [1, 2, 3, 4, 5, 6, 7, 8, 13, 16, 17, 19, 21, 29, 35, 41, 44],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Grecji z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Grecji?',
                turnOnBtnText: 'Włącz sprzedaż do Grecji',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174754&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174777&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce w Grecji',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175011&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/buduj-wlasna-marke-i-sprzedawaj-w-europie-srodkowo-wschodniej-dlaczego-warto-wejsc-w-cross-border-wlasnie-teraz-1235327482',
                        },
                    ],
                },
            },
            name: 'Grecja',
            population: '10,3 mln',
            language: 'grecki',
            popularPayment: 'Płatności za pobraniem',
            currency: 'EUR',
            numberOfEstores: '79%',
            trends: [
                'Cena odgrywa kluczową rolę przy zakupie',
                '35 proc. kupujących online już kupuje w modelu cross-border',
                'Najpopularniejsza branża to Fashion',
                'Skroutz.gr daje dostęp do 8,5 mln użytkowników',
            ],
            growthRate: '13,4%',
            cta: {
                name: 'Przejdż do podstrony o Grecji',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=173547&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Grecji',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do Grecji. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Skieruj ruch bezpośrednio do sklepu poprzez popularną porównywarkę cenową Skroutz.gr. Dzięki integracji z Packeta otrzymasz dostęp do sieci lokalnych kurierów oraz punktów odbioru. ',
                    },
                ],
            },
            integrations: [1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 19, 29, 35, 43],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Austrii z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Austrii?',
                turnOnBtnText: 'Włącz sprzedaż do Austrii',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174762&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174772&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce w Austrii',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175003&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/integracja-idosell-z-geizhals-i-guenstiger-wlacz-nowe-porownywarki-cenowe-dla-niemiec-i-austrii-1235327612',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                    ],
                },
            },
            name: 'Austria',
            population: '9,1 mln',
            language: 'niemiecki',
            popularPayment: 'Mastercard, Visa, portfele cyfrowe, otwarte faktury',
            currency: 'EUR',
            numberOfEstores: '95,72%',
            trends: [
                'Najpopularniejsza metoda dostawy to austriacka poczta, DHL jest na drugim miejscu (30% sklepów)',
                'Ponad jedna trzecia Austriaków robi zakupy na smartfonie',
                'Około 72% mieszkańców Austrii zrobiło zakupy online w ciągu ostatnich 12 miesięcy',
            ],
            growthRate: '4.6%',
            cta: {
                name: 'Przejdż do podstrony o Austrii',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=174101&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Austrii',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania. Zacznij już teraz!',
                        content:
                            'Bez dodatkowych prac uruchomisz integracje z serwisami i dostawcami usług dla handlu cross-border. Testuj nowe rynki poprzez marketplace lub od razu uruchom sklep zagraniczny, wspierany ruchem z lokalnych porównywarek cenowych i Google Ads. ',
                    },
                ],
            },
            integrations: [1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 27, 28, 29, 37, 38],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Francji z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce we Frencji?',
                turnOnBtnText: 'Włącz sprzedaż do Francji',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174756&ext=.png',
                countryOutlineImg:
                    'https://www.idosell.com/panel/file-gate.php?id=174767}&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce we Francji',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=174905&ext=.png',
                            link: 'https://www.idosell.com/pl/baza-wiedzy/webinary/cross-border-czyli-dlaczego-warto-sprzedawac-za-granica/',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                    ],
                },
            },

            name: 'Francja',
            population: '67,97 mln',
            language: 'francuski',
            popularPayment: 'Mastercard, Visa, portfele cyfrowe',
            currency: 'EUR',
            numberOfEstores: '93,79%',
            trends: [
                'Silna pozycja lokalnego marketplace Cdiscount, który jest częściej odwiedzany niż Amazon',
                'Aż 85% kupujących wybiera dostawę do domu i ponad 1/3 oczekuje, że będzie ona darmowa',
                'Francuzi szczególnie upodobali sobie model zakupów "click and collect" (kliknij i odbierz), gdzie produkty zamawiane są online, a odbierane w fizycznych punktach',
            ],
            growthRate: '4,6%',
            cta: {
                name: 'Przejdż do podstrony o Francji',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=174099&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży we Francji',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do Francji. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Dotrzyj do milionów kupujących dzięki integracji z marketplace - nie tylko Amazon, eBay oraz Wish. Sprzedawaj swoje towary również na popularnym we Francji CDiscount. ',
                    },
                ],
            },
            integrations: [
                1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 19, 27, 28, 29, 31, 32, 35, 36, 37,
                44,
            ],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Włoch z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce we Włoszech?',
                turnOnBtnText: 'Włącz sprzedaż do Włoch',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174760&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174765&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce we Włoszech',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=174905&ext=.png',
                            link: 'https://www.idosell.com/pl/baza-wiedzy/webinary/cross-border-czyli-dlaczego-warto-sprzedawac-za-granica/',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                    ],
                },
            },
            name: 'Włochy',
            population: '59 mln',
            language: 'włoski',
            popularPayment: 'Mastercard, Visa, Klarna',
            currency: 'EUR',
            numberOfEstores: '87,71%',
            trends: [
                'Najwięcej dostaw dla e-commerce obsługuje BRT Bartollini, firma należąca do DPD',
                'Najczęściej odwiedzanym lokalnym marketplace jest subito.it (specjalize się w sprzedaży rzeczy używanych). Wyprzedza go tylko eBay i Amazon',
                'Płatność kartą VISA to najczęściej wybierana opcja w sklepach internetowych (aż 41%). Obserwuje się wzrost popularności innych płatności - PayPal, Apple Pay czy Google Pay',
            ],
            growthRate: '8%',
            cta: {
                name: 'Przejdż do podstrony o Włoszech',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=174104&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży we Włoszech',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do Włoch. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Dotrzyj do milionów kupujących dzięki integracji z marketplace Amazon, eBay oraz Wish. Płatności w euro w swoim sklepie rozliczysz bez przewalutowania dzięki IdoPay. ',
                    },
                ],
            },
            integrations: [
                1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 19, 27, 28, 29, 35, 37, 44,
            ],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Wielkiej Brytanii z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Wielkiej Brytanii?',
                turnOnBtnText: 'Włącz sprzedaż do Wielkiej Brytanii',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174757&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174778&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce we Włoszech',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=174905&ext=.png',
                            link: 'https://www.idosell.com/pl/baza-wiedzy/webinary/cross-border-czyli-dlaczego-warto-sprzedawac-za-granica/',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                    ],
                },
            },
            name: 'WielkaBrytania',
            population: '67 mln',
            language: 'angielski',
            popularPayment: 'Mastercard, Visa, portfele cyfrowe, klarna',
            currency: 'GBP',
            numberOfEstores: '99%',
            trends: [
                'Szczególnie popularne są zakupy na urządzeniach mobilnych. Tylko 30% transakcji dokonywanych jest przez desktop',
                'Brytyjczycy przywiązują dużą wagę do rekomendacji innych klientów – ponad połowa konsumentów czyta opinie przed zakupem',
                'Royal Mail obsługuje 35% dostaw zakupów online. Amazon Logistics i Hermes mają odpowiednio 15% i 10% udziału w rynku',
            ],
            growthRate: '6,4%',
            cta: {
                name: 'Przejdż do podstrony o Wielkiej Brytanii',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=174100&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Wielkiej Brytanii',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do Wielkiej Brytanii. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Dotrzyj do milionów kupujących dzięki integracji z marketplace Amazon, eBay oraz Wish. Płatności w funtach w swoim sklepie rozliczysz bez przewalutowania dzięki IdoPay. ',
                    },
                ],
            },
            integrations: [
                1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 19, 24, 25, 26, 27, 28, 29, 35, 36,
                37, 44,
            ],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Hiszpanii z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Hiszpanii?',
                turnOnBtnText: 'Włącz sprzedaż do Hiszpanii',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174759&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174766&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce we Włoszech',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=174905&ext=.png',
                            link: 'https://www.idosell.com/pl/baza-wiedzy/webinary/cross-border-czyli-dlaczego-warto-sprzedawac-za-granica/',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                    ],
                },
            },
            name: 'Hiszpania',
            population: '48 mln',
            language: 'hiszpański',
            popularPayment: 'Mastercard, Visa, portfele cyfrowe, Klarna',
            currency: 'EUR',
            numberOfEstores: '96%',
            trends: [
                'Największą liczbę przesyłek dostarczają UPS, DHL i GLS - ale nie ma tu jednego wyraźnego lidera',
                'Hiszpanie chętnie robią zakupy na zagranicznych stronach (Chiny, USA, Niemcy)',
                'Ekologiczne produkty i marki oraz odpowiedzialność społeczna stają się kluczowym trendem w branży fashion',
            ],
            growthRate: '9,9%',
            cta: {
                name: 'Przejdż do podstrony o Hiszpanii',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=174355&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Hiszpanii',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do Hiszpanii. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Dotrzyj do milionów kupujących dzięki integracji z marketplace Amazon, eBay oraz Wish. Płatności w euro w swoim sklepie rozliczysz bez przewalutowania dzięki IdoPay. ',
                    },
                ],
            },
            integrations: [
                1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 19, 27, 28, 29, 35, 37, 44,
            ],
        },

        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Holandii z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce w Holandii?',
                turnOnBtnText: 'Włącz sprzedaż do Holandii',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174761&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174763&ext=.png',
                webinars: {
                    title: 'Dowiedz się więcej o e-commerce we Włoszech',
                    elements: [
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=174905&ext=.png',
                            link: 'https://www.idosell.com/pl/baza-wiedzy/webinary/cross-border-czyli-dlaczego-warto-sprzedawac-za-granica/',
                        },
                        {
                            img: 'https://www.idosell.com/panel/file-gate.php?id=175004&ext=.png',
                            link: 'https://www.idosell.com/pl/blog/wyzwania-w-handlu-cross-border-jak-skutecznie-przygotowac-sklep-do-sprzedazy-miedzynarodowej-1235327496',
                        },
                    ],
                },
            },
            name: 'Holandia',
            population: '17,8 mln',
            language: 'holenderski',
            popularPayment: 'iDEAL, Mastercard, Visa, portfele cyfrowe, Klarna',
            currency: 'EUR',
            numberOfEstores: '99%',
            trends: [
                'Ulubioną formą płatności jest jest holenderski system międzybankowy iDEAL (prawie 3/4 wszystkich zakupów)',
                'Bardzo silna pozycja lokalnego marketplace bol.com, który ma większy udział regularnych kupujących niż Amazon',
                'Holendrzy najczęściej zamawiają z dostawą do domu a 3/4 dostaw obsługuje holenderska poczta',
            ],
            growthRate: '4,2%',
            cta: {
                name: 'Przejdż do podstrony o Holandii',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=174102&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży w Holandii',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania do Holandii. Zacznij już teraz!',
                        content:
                            'W IdoSell dajemy ci gotowe rozwiązania. Dotrzyj do milionów kupujących dzięki integracji z marketplace Amazon, eBay oraz Wish. Klienci w twoim sklepie będą mogli zapłacić poprzez PayPal, Klarna lub Stripe. ',
                    },
                ],
            },
            integrations: [1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 19, 27, 29, 35, 44],
        },
        {
            infoOnSpecificPage: {
                pageTitle: 'Zacznij sprzedawać do Ukrainy z IdoSell',
                howSaleLooks: 'Jak wygląda e-commerce na Ukrainie?',
                turnOnBtnText: 'Włącz sprzedaż do Ukrainy',
                heroImg: 'https://www.idosell.com/panel/file-gate.php?id=174758&ext=.png',
                countryOutlineImg: 'https://www.idosell.com/panel/file-gate.php?id=174768&ext=.png',
            },
            name: 'Ukraina',
            population: 'X mln',
            language: 'X',
            popularPayment: 'XX',
            currency: 'xxx',
            numberOfEstores: 'X',
            trends: ['XXX', 'XXX', 'XXX'],
            growthRate: 'X',
            cta: {
                name: 'Przejdż do podstrony o Ukrainie',
                link: 'https://www.idosell.com/pl/',
            },
            img: 'https://www.idosell.com/panel/file-gate.php?id=174103&ext=.png',
            integrationsTitle: 'Zobacz proponowane rozwiązania do sprzedaży na Ukrainie',
            whyCrossBorderIdosell: {
                title: 'Dlaczego warto sprzedawać w cross-border z IdoSell?',
                description:
                    'Sprzedaż międzynarodowa to przyszłość e-commerce. Rynek w Polsce jest już bardzo konkurencyjny, dlatego warto wyjść z ofertą także do innych krajów. Wykorzystaj ten potencjał i zacznij sprzedawać za granicę już teraz. Dzięki IdoSell będzie to proste i skuteczne:',
                elements: [
                    {
                        header: 'Znamy zwyczaje i preferencje kupujących w każdym kraju',
                        content:
                            'Mamy know-how na temat rynków europejskich. Pomożemy ci dobrać odpowiednich partnerów zagranicznych i zacząć skutecznie sprzedawać w modelu cross-border. ',
                    },
                    {
                        header: 'IdoSell to proste i gotowe rozwiązania. Zacznij już teraz!',
                        content:
                            'Bez dodatkowych prac uruchomisz integracje z serwisami i dostawcami usług dla handlu cross-border. Testuj nowe rynki poprzez marketplace lub od razu uruchom sklep zagraniczny, wspierany ruchem z lokalnych porównywarek cenowych i Google Ads. ',
                    },
                ],
            },
            integrations: [16, 22],
        },
    ];

    // ,category 1=Logistyka, 2=Płatności, 3=Źródła ruchu
    // ,category 1=Logistyka, 2=Płatności, 3=Źródła ruchu
    const integrationsList = [
        {
            id: 1,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180044&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/systemy-platnosci-obslugiwane-w-idosell/sklep-internetowy-idosell-z-platnosciami-paypal/',
            category: 2,
        },
        {
            id: 2,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180045&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/systemy-platnosci-obslugiwane-w-idosell/integracja-sklepu-internetowego-z-systemem-platnosci-payu/',
            category: 2,
        },
        {
            id: 3,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180083&ext=.png',
            link: 'https://www.idosell.com/pl/platnosci/stripe/',
            category: 2,
        },
        {
            id: 4,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180081&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/systemy-platnosci-obslugiwane-w-idosell/klarna/',
            category: 2,
        },
        {
            id: 5,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180057&ext=.png',
            link: '#',
            category: 2,
        },
        {
            id: 6,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180079&ext=.png',
            link: '#',
            category: 2,
        },
        {
            id: 7,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180071&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/systemy-platnosci-obslugiwane-w-idosell/apple-pay/',
            category: 2,
        },
        {
            id: 8,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180063&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/systemy-platnosci-obslugiwane-w-idosell/google-pay/',
            category: 2,
        },
        {
            id: 9,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180139&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/systemy-platnosci-obslugiwane-w-idosell/yandex-money-obsluguje-transakcje-platnicze-w-wybranych-krajach-europy-i-azji/',
            category: 2,
        },
        {
            // id: 10,
            // img: "https://www.idosell.com/panel/file-gate.php?id=180136&ext=.png",
            // link: "#",
            // category: 2,
        },
        {
            // id: 11,
            // img: "https://www.idosell.com/panel/file-gate.php?id=180084&ext=.png",
            // link: "https://www.idosell.com/pl/blog/platnosci-odroczone-twisto-payu-place-pozniej-1235327368",
            // category: 2,
        },
        {
            id: 12,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180067&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/zintegrowani-kurierzy/integracja-sklepu-z-uslugami-kurierskimi-dhl-express/',
            category: 1,
        },
        {
            id: 13,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180077&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/zintegrowani-kurierzy/w-iai-shop-com-mozesz-generowac-liste-zamowien-na-potrzeby-generowania-etykiet-w-dpd-geoship-bezposrednio-z-panelu-sklepu-internetowego/',
            category: 1,
        },
        {
            id: 14,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180080&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/zintegrowani-kurierzy/integracja-dla-sklepow-internetowych-idosell-z-kurierem-ups/',
            category: 1,
        },
        {
            id: 15,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180060&ext=.png',
            link: 'https://www.idosell.com/pl/kurierzy/',
            category: 1,
        },
        {
            id: 16,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180058&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/zintegrowani-kurierzy/integracja-z-kurierem-gls-poland-w-iai-shop-com/',
            category: 1,
        },
        {
            id: 17,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180064&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/zintegrowani-kurierzy/packeta/',
            category: 1,
        },
        {
            id: 18,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180047&ext=.png',
            link: '#',
            category: 1,
        },
        {
            id: 19,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180072&ext=.png',
            link: 'https://www.idosell.com/pl/mozliwosci-systemu-wms-w-sklepach-internetowych/fulfillment-czyli-kompleksowa-obsluga-procesow-magazynowych-przez-wyspecjalizowana-firme-zewnetrzna/fulfillment-integracja-frisbo/',
            category: 1,
        },
        {
            id: 20,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180076&ext=.png',
            link: 'https://www.idosell.com/pl/kurierzy/',
            category: 1,
        },
        {
            id: 21,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180065&ext=.png',
            link: '#',
            category: 1,
        },
        {
            id: 22,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180086&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/zintegrowani-kurierzy/elektroniczny-nadawca-poczty-polskiej-w-idosell/',
            category: 1,
        },
        {
            id: 23,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180062&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/zintegrowani-kurierzy/szybka-i-wygodna-dostawa-inpost-kurier-dostepna-bez-umowy-i-deklaracji-ilosci-dzieki-wspolpracy-idosell-i-inpost/',
            category: 1,
        },
        {
            // id: 24,
            // img: "https://www.idosell.com/panel/file-gate.php?id=180137&ext=.png",
            // link: "#",
            // category: 1,
        },
        {
            id: 25,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180043&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/zintegrowani-kurierzy/royal-mail-integracja-z-brytyjskim-operatorem-narodowym-przez-despatch-manager-online/',
            category: 1,
        },
        {
            // id: 26,
            // img: "https://www.idosell.com/panel/file-gate.php?id=180069&ext=.png",
            // link: "#",
            // category: 1,
        },
        {
            id: 27,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180040&ext=.png',
            link: 'https://www.idosell.com/pl/amazon/',
            category: 3,
        },
        {
            id: 28,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180046&ext=.png',
            link: 'https://www.idosell.com/pl/allegro-ebay/',
            category: 3,
        },
        {
            id: 29,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180088&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/wish/',
            category: 3,
        },
        {
            id: 30,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180078&ext=.png',
            link: '#',
            category: 3,
        },
        {
            id: 31,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180068&ext=.png',
            link: 'https://www.idosell.com/pl/marketplaces-sprzedawaj-swoje-towary-w-wielu-miejscach-jednoczesnie-na-calym-swiecie/cdiscount/',
            category: 3,
        },
        {
            id: 32,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180066&ext=.png',
            link: 'https://www.idosell.com/pl/marketplaces/spartoo/',
            category: 3,
        },
        {
            id: 33,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180089&ext=.png',
            link: 'https://www.idosell.com/pl/allegro-ebay/',
            category: 3,
        },
        {
            id: 34,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180085&ext=.png',
            link: '#',
            category: 3,
        },
        {
            id: 35,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180087&ext=.png',
            link: 'https://www.idosell.com/pl/blog/integracja-z-miedzynarodowymi-porownywarkami-shopzilla-idealo-oraz-shopmania-1235324738',
            category: 3,
        },
        {
            id: 36,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180059&ext=.png',
            link: 'https://www.idosell.com/pl/blog/integracja-z-miedzynarodowymi-porownywarkami-shopzilla-idealo-oraz-shopmania-1235324738',
            category: 3,
        },
        {
            id: 37,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180073&ext=.png',
            link: 'https://www.idosell.com/pl/blog/integracja-z-miedzynarodowymi-porownywarkami-shopzilla-idealo-oraz-shopmania-1235324738',
            category: 3,
        },
        {
            id: 38,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180070&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/porownywarki-cen-serwisy-opinii-katalogi-produktow-generuj-oferty-bez-skladania-zamowien-w-wielu-miejscach-jednoczesnie/dotrzyj-do-3-3-mln-klientow-dzieki-integracji-z-geizhals/',
            category: 3,
        },
        {
            id: 39,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180075&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/porownywarki-cen-serwisy-opinii-katalogi-produktow-generuj-oferty-bez-skladania-zamowien-w-wielu-miejscach-jednoczesnie/przyciagnij-niemieckich-klientow-do-swojego-sklepu/',
            category: 3,
        },
        {
            id: 40,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180061&ext=.png',
            link: '#',
            category: 3,
        },
        {
            id: 41,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180091&ext=.png',
            link: '#',
            category: 3,
        },
        {
            id: 42,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180074&ext=.png',
            link: '#',
            category: 3,
        },
        {
            id: 43,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180039&ext=.png',
            link: '#',
            category: 3,
        },
        {
            id: 44,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180082&ext=.png',
            link: 'https://www.idosell.com/pl/integracje-gotowe-do-wlaczenia-jednym-kliknieciem-/porownywarki-cen-serwisy-opinii-katalogi-produktow-generuj-oferty-bez-skladania-zamowien-w-wielu-miejscach-jednoczesnie/integracja-sklepu-internetowego-z-kelkoo/',
            category: 3,
        },
        {
            id: 45,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180090&ext=.png',
            link: '#',
            category: 3,
        },
        {
            id: 46,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180092&ext=.png',
            link: '#',
            category: 3,
        },
        {
            id: 47,
            img: 'https://www.idosell.com/panel/file-gate.php?id=180093&ext=.png',
            link: '#',
            category: 3,
        },
    ];

    const crossBorderInfo = document.querySelector('.crossBorder-countryInfo');
    const crossBorderMap = document.querySelector('.crossBorder-map');
    const crossBorderList = document.querySelector('.crossBorder-list');
    const switchViewModeInput = document.querySelector('.switchViewMode input');
    const countrylinkContainer = document.getElementById('country__info');
    const countriesOnMap = document.querySelectorAll('.crossBorder-map svg > g > g >g  ');
    const integrationsLogisticContainer = document.querySelector(
        '.crossBorder-integrations__logistics',
    );
    const integrationsPaymentsContainer = document.querySelector(
        '.crossBorder-integrations__payments',
    );
    const integrationsTrafficContainer = document.querySelector(
        '.crossBorder-integrations__traffic',
    );

    const changeIntegrationsList = (country = null) => {
        console.log('integrationsintegrationsintegrations', country);

        let availableIntegrations = [];
        const integrationsCountryInfo = document.querySelector('.integrationsCountryInfo');
        if (country) {
            const countryInfo = countriesList.find(obj => {
                return obj.name === country;
            });
            integrationsList.map(element => {
                if (countryInfo.integrations.includes(element.id)) {
                    availableIntegrations.push(element.id);
                }
            });
            integrationsCountryInfo.textContent = countryInfo.integrationsTitle;
        } else {
            integrationsCountryInfo.textContent = 'Sprawdź wszystkie integracje';
        }

        //logistic
        const integrationLogisticBody = document.createElement('div');
        integrationLogisticBody.classList.add('categoryBody');

        integrationsLogisticContainer.innerHTML = `
      <span class='categoryTitle'>Logistyka</span>`;
        integrationLogisticBody.innerHTML += integrationsList
            .map(integration => {
                if (
                    (availableIntegrations.includes(integration.id) || country == null) &&
                    integration.category == 1
                ) {
                    if (!integration.link || integration.link === '#') {
                        return `
            <div class="integrations-item">
                <a target="_blank"
                 class=" imgContainer imgContainer--imgContain">
               <img src=${integration.img}  loading="lazy">
                </a>
            </div>
            `;
                    } else {
                        return `
            <div class="integrations-item">
                <a  href=${integration.link} target="_blank"
                 class=" imgContainer imgContainer--imgContain">
               <img src=${integration.img}  loading="lazy">
                </a>
            </div>
            `;
                    }
                }
            })
            .join('');
        integrationsLogisticContainer.append(integrationLogisticBody);

        // payments
        const integrationPaymentsBody = document.createElement('div');
        integrationPaymentsBody.classList.add('categoryBody');

        integrationsPaymentsContainer.innerHTML = `
        <span class='categoryTitle'>Płatności</span>`;
        integrationPaymentsBody.innerHTML += integrationsList
            .map(integration => {
                if (
                    (availableIntegrations.includes(integration.id) || country == null) &&
                    integration.category == 2
                ) {
                    if (!integration.link || integration.link === '#') {
                        return `
            <div class="integrations-item">
                <a  target="_blank"
                 class=" imgContainer imgContainer--imgContain">
               <img src=${integration.img}  loading="lazy">
                </a>
            </div>
            `;
                    } else {
                        return `
            <div class="integrations-item">
                <a  href=${integration.link} target="_blank"
                 class=" imgContainer imgContainer--imgContain">
               <img src=${integration.img}  loading="lazy">
                </a>
            </div>
            `;
                    }
                }
            })
            .join('');
        integrationsPaymentsContainer.append(integrationPaymentsBody);

        // traffic
        const integrationTrafficBody = document.createElement('div');
        integrationTrafficBody.classList.add('categoryBody');

        integrationsTrafficContainer.innerHTML = `
        <span class='categoryTitle'>Źrodła ruchu</span>`;
        integrationTrafficBody.innerHTML += integrationsList
            .map(integration => {
                if (
                    (availableIntegrations.includes(integration.id) || country == null) &&
                    integration.category == 3
                ) {
                    if (!integration.link || integration.link === '#') {
                        return `
            <div class="integrations-item">
                <a  target="_blank"
                 class=" imgContainer imgContainer--imgContain">
               <img src=${integration.img}  loading="lazy">
                </a>
            </div>
            `;
                    } else {
                        return `
            <div class="integrations-item">
                <a  href=${integration.link} target="_blank"
                 class=" imgContainer imgContainer--imgContain">
               <img src=${integration.img}  loading="lazy">
                </a>
            </div></div>
            `;
                    }
                }
            })
            .join('');
        integrationsTrafficContainer.append(integrationTrafficBody);
    };

    const crossBorderInfoRestoreDefault = () => {
        //Show all integrations
        //    changeIntegrationsList();

        // restore default info in crossborder info section
        crossBorderInfo.innerHTML = `
          <div class="crossBorder-countryInfo-default">
              <h2 class="map_title">Poznaj najważniejsze informacje oraz lokalne trendy danego kraju</h2>
              <p class="map_adding">Kliknij w kraj i poznaj dedykowane rozwiązania od IdoSell</p>
          </div>
      `;
        countrylinkContainer.innerHTML = '';
        countrylinkContainer.style.display = 'inline-block';
        countrylinkContainer.style.marginLeft = '15px';

        const buttonsOnList = document.querySelectorAll('.crossBorder-list button');
        //restore default classes on buttons in list
        buttonsOnList.forEach(btn => {
            btn.classList.remove('active');
        });

        //restore default view to map
        countriesOnMap.forEach(country => {
            country.classList.remove('country--dimmed', 'country--active');
        });
    };

    //

    const crossborder = () => {
        console.log('corssborder', crossBorderInfo);
        if (!crossBorderInfo) return;

        const putCountriesToList = () => {
            // put countriesList to list on start aplictation (only once)
            let itemsList = document.createDocumentFragment();
            countriesList.map(country => {
                const btn = document.createElement('button');
                let countryName = country.name;
                if (country.name == 'WielkaBrytania') {
                    countryName = 'Wielka Brytania';
                }
                btn.textContent = countryName;
                btn.classList.add(`btnOnList-${country.name}`);
                btn.addEventListener('click', () => {
                    activeCountry(country.name);
                });
                itemsList.appendChild(btn);
            });

            crossBorderList.appendChild(itemsList);
        };

        const changeViewMode = () => {
            //change view mode to map or list. Default is map.
            crossBorderMap.classList.toggle('off');
            crossBorderList.classList.toggle('off');
        };

        const activeCountry = name => {
            // The function takes as an argument the name of the country (which must be contained in the countriesList array)

            console.log('name', name);

            const crossBorderInfoChangeTemplate = name => {
                //change info template about country in crossborder info section (after click on country)
                const countryInfo = countriesList.find(obj => {
                    return obj.name === name;
                });
                const trends = countryInfo.trends
                    .map(trend => {
                        return `<li>${trend}</li>`;
                    })
                    .join('');
                let countryName = countryInfo.name;
                if (countryInfo.name == 'WielkaBrytania') {
                    countryName = 'Wielka Brytania';
                }

                const countryLink = `https://www.idosell.com/pl/sprzedaz-miedzynarodowa-w-sklepie-internetowym-idosell/cross-border/?&country=${countryInfo.name}`;

                crossBorderInfo.innerHTML = `
              <div class="crossBorder-countryInfo-country">
              <div>
           
                  <div class="country_info__name_flag_contaianer"><span><strong>${countryName}</strong></span><img src=${countryInfo.img} alt='flaga' /></div>
                  <div class="country_info__container"><span class="country_info__name">Liczba mieszkańców</span><span class="country_info__value"> ${countryInfo.population}</span></div>
                  <div class="country_info__container"><span class="country_info__name">Mieszkańcy z dostępem do internetu:</span><span class="country_info__value">${countryInfo.numberOfEstores}</span></div>
                  <div class="country_info__container"><span class="country_info__name">Prognozowany wzrost rynku e-commerce (2024-2028)</span><span class="country_info__value">${countryInfo.growthRate}</span></div>
                
                  <div class="country_info__local_trends">
                    <span class="local_trends__title">Lokalne trendy: </span>
                    <ul class="local_trends__list">
                        ${trends}
                    </ul>
                  </div>
                </div> 
         </div>
        `;
                const btnClose = document.createElement('img');
                countrylinkContainer.innerHTML = `<a href=${countryLink} target="_blank" class="link --underline">${countryInfo.cta.name}</a>`;

                // eslint-disable-next-line no-unused-expressions
                (btnClose.src = 'https://www.idosell.com/panel/file-gate.php?id=175341&ext=.png'),
                    (btnClose.className = 'crossBorder__closeBtn'),
                    btnClose.addEventListener('click', crossBorderInfoRestoreDefault);
                crossBorderInfo.appendChild(btnClose);
            };

            const activeCountryOnList = activeBtn => {
                //change class 'active' to button county(after clicked on list or on map)
                const buttonsOnList = document.querySelectorAll('.crossBorder-list button');
                buttonsOnList.forEach(btn => {
                    //add active class to active country, remove from other countriesList
                    if (btn == activeBtn) {
                        btn.classList.add('active');
                    } else {
                        btn.classList.remove('active');
                    }
                });
            };

            const activeCountryOnMap = activeElement => {
                //change class 'active' to svg group element country(after clicked on list or on map)
                countriesOnMap.forEach(country => {
                    //add active class to active country, remove from other countriesList
                    if (country == activeElement) {
                        activeElement.classList.add('country--active');
                        activeElement.classList.remove('country--dimmed');
                    } else {
                        country.classList.add('country--dimmed');
                        country.classList.remove('country--active');
                    }
                });
            };

            const countryButtonElementOnList = document.querySelector(`.btnOnList-${name}`);
            const svgElementOnMap = document.querySelector(`#${name}`).parentNode;

            if (svgElementOnMap.classList.contains('country--active')) {
                // It means that someone has clicked on an already active country
                // So we only reset the view to the default
                crossBorderInfoRestoreDefault();
                // //Show all integrations
                // changeIntegrationsList();
                return;
            }

            // Change the contents of the integration list
            crossBorderInfoChangeTemplate(name);

            //change
            //changeIntegrationsList(name);

            //Change class 'active' to clicked country on list
            activeCountryOnList(countryButtonElementOnList);

            //change classes on map elemenets
            activeCountryOnMap(svgElementOnMap);
        };

        countriesOnMap.forEach(country => {
            country.addEventListener('click', e => {
                activeCountry(country.querySelector('text').id);
            });
        });

        //change view mode to map or list. On mobile default is list. Switich is visable only on mobile.
        switchViewModeInput.addEventListener('change', changeViewMode);
        const isMobile = window.matchMedia('(max-width: 370px)');
        if (isMobile.matches) {
            // show list view by default on mobile
            changeViewMode();
            switchViewModeInput.checked = false;
        }

        putCountriesToList();
        console.log('countriesOnMap', countriesOnMap);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const countryNameFromQuery = urlParams.get('country');
        if (countryNameFromQuery) {
            // If the url contains a country, run it
            activeCountry(countryNameFromQuery);
            //  changeIntegrationsList(countryNameFromQuery);
        } else {
            // If the url doesn't contain a country, run default view
            crossBorderInfoRestoreDefault();
            //  changeIntegrationsList();
        }
    };

    crossborder();
};

document.addEventListener('DOMContentLoaded', function (event) {
    setTimeout(() => {
        crossBorderInit();
    }, 1000);
});
